<svg
    [attr.preserveAspectRatio]="preserveRatio ? 'xMidYMid' : 'none'"
    [ngClass]="additionalClasses"
    class="-mb-px"
    viewBox="4 0 1280 142"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g>
        <path
            class="fill-current"
            d="M 799.761 105.41 C 964.262 155.64 1215.05 144.432 1286.5 71.5 V 108 L 1286.5 126.5 L 1286.5 135 L 1286.5 144 V 143 H 4 V 47 C 4 47 88.9375 0 224.588 0 C 487.405 -0 658.972 62.4206 799.761 105.41 Z" />
    </g>
</svg>
